import {
  getDetails,
  getInitCollection,
  getLatestZdcollection,
} from '@/api';

const localState = {
  collectionId: 1,
  details: [],
  deviceInitCollection: {},
  collectionTime: [], // 通用的时间设置
  frequency: 0,
};

const actions = {
  async changeCollectionId({ commit }, { collectionId }) {
    commit('setCollectionId', { collectionId });
    const res = await getDetails(collectionId);
    commit('setDetails', { details: res.data.details });
  },
  // 获取初始采集
  async getInitCollection({ state, commit }, {
    deviceId,
    coorSystem,
    coorx,
    coory,
    convertAB,
    touchInit = true, // 该字段暂时没用上
  }) {
    let initCollection;
    // 取缓存，默认不从缓存中获取，即默认发起请求
    if (!touchInit) {
      initCollection = state.deviceInitCollection[deviceId];
    }
    if (initCollection) return initCollection;

    const res = await getInitCollection({ deviceId });
    // eslint-disable-next-line
    initCollection = res.data.initCollection;

    if (convertAB) { // 是否需要转为ab坐标
      if (coorSystem === 'AB') {
        initCollection.Details.forEach((d) => {
          const { x, y } = d;
          switch (coorx) {
            case '-X':
              d.x = -x; break;
            case 'Y':
              d.x = y; break;
            case '-Y':
              d.x = -y; break;
            default:
              d.x = x;
          }

          switch (coory) {
            case '-Y':
              d.y = -y; break;
            case 'X':
              d.y = x; break;
            case '-X':
              d.y = -x; break;
            default:
              d.y = y;
          }
        });
      }
    }

    commit('setInitCollection', { deviceId, initCollection });
    return initCollection;
  },
  async getLatestZdcollection(context, { deviceId }) {
    const res = await getLatestZdcollection({ deviceId });
    const { code, msg, latestCollection } = res.data;
    if (code !== 0) throw new Error(msg);
    return latestCollection;
  },
};

const mutations = {
  setCollectionId(state, { collectionId }) {
    state.collectionId = collectionId;
  },
  setDetails(state, { details }) {
    state.details = details;
  },
  setInitCollection(state, { deviceId, initCollection }) {
    state.deviceInitCollection[deviceId] = initCollection;
  },
  resetInitCollection(state, { deviceId }) { // 重新初始化
    state.deviceInitCollection[deviceId] = null;
  },
  setCollectionTime(state, data) {
    state.collectionTime = data;
  },
  setFrequency(state, data) {
    state.frequency = data;
  },
};

export default {
  actions,
  mutations,
  state: localState,
  namespaced: true,
};

